import React from 'react';

export type FieldProps = React.HTMLAttributes<HTMLDivElement> & {
  label?: React.ReactNode;
  hint?: React.ReactNode;
  htmlFor?: string;
};

export const Field: React.FC<FieldProps> = ({
  label,
  hint,
  htmlFor,
  className = '',
  children,
  ...rest
}) => (
  <div className={`field ${className}`} {...rest}>
    {label && (
      <label className="field-label" htmlFor={htmlFor}>
        {label}
      </label>
    )}
    {children}
    {hint && <span className="field-hint">{hint}</span>}
  </div>
);

export const FieldLabel: React.FC<React.LabelHTMLAttributes<HTMLLabelElement>> = ({
  className = '',
  ...rest
}) => <label className={`field-label ${className}`} {...rest} />;

export const FieldHint: React.FC<React.HTMLAttributes<HTMLSpanElement>> = ({
  className = '',
  ...rest
}) => <span className={`field-hint ${className}`} {...rest} />;

export const Check: React.FC<
  React.LabelHTMLAttributes<HTMLLabelElement> & { children: React.ReactNode }
> = ({ className = '', children, ...rest }) => (
  <label className={`check ${className}`} {...rest}>
    {children}
  </label>
);
